export const selectedPlaceToAdd = state => state.userAction.selectedPlaceToAdd;
export const openStepId = state => state.userAction.openStepId;
export const currentPage = state => state.userAction.currentPage;
export const openTags = state => state.userAction.openTags;
export const pendingChangedLocations = state => state.userAction.pendingChangedLocations;
export const expiredToken = state => state.userAction.expiredToken;
export const goto = state => state.userAction.goto;
